import { axiosDefault } from '@/core/utils';
import {
	UpdateSelectedNetworkRequest,
	UpdateSelectedNetworkResponse,
} from '@/core/interfaces';

const updateSelectedNetwork = async ({
	id,
}: UpdateSelectedNetworkRequest): Promise<UpdateSelectedNetworkResponse> => {
	const url = `/tg/user/extra/chain-id?value=${id}`;
	const response = await axiosDefault.put(url, null);
	return response.data;
};

export const NetworkService = {
	updateSelectedNetwork,
};
